module.exports = __webpack_public_path__ + "img/female-condom_x2.8d69ca63.png";